import React, { useState, useContext } from "react";
import {
  Avatar,
  Box,
  Paper,
  Container,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import Page from "components/Page";
import { EditOutlined } from "@material-ui/icons";
import { GET_SHIFTS } from "lib/shifts";
import { GetShiftsQueryResult, Task } from "generated/graphql";

export default function ShiftsData() {
  const history = useHistory();
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const { loading, error, data }: GetShiftsQueryResult = useQuery(GET_SHIFTS, {
    variables: {
      limit,
      offset: limit * page,
      buildingId: currentBuilding?.Id,
    },
  });

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const handleEditClick = (id: string) => {};

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const rows = data?.Shift.map((object) => ({
    id: object?.Id,
    Description: object?.Description,
    StartDateTime: object?.StartDateTime,
    EndDateTime: object?.EndDateTime,
  }));

  const columns = [
    { field: "id", width: 150 },
    { field: "Description", headerName: "Description", width: 150 },
    {
      field: "StartDateTime",
      headerName: "Start Time",
      width: 150,
    },
    {
      field: "EndDateTime",
      headerName: "End Time",
      width: 150,
    },
  ];

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Shift) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  // @ts-ignore
                  rows={rows}
                  pagination
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 20]}
                  checkboxSelection
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                ></DataGrid>
              </div>
            </Box>
          </PerfectScrollbar>
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Shifts</div>;
  }
}
